import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/zh-tw';

import { connect } from 'react-redux';
import { getGame } from '../actions/game';

import { Row, Col, Skeleton, Divider } from 'antd';
import { Helmet } from 'react-helmet';

import LogoButton from "./LogoButton";
import OpenAppButton from "./OpenAppButton";

import hostImg from '../assets/images/icon-game-info-info-16@3x.png';
import rewardImg from '../assets/images/icon-tag-prize@3x.png';
import freeImg from '../assets/images/icon-tag-free@3x.png';
import gameTimeImg from '../assets/images/icon-game-info-time-20@3x.png';
import targetImg from '../assets/images/icon-game-info-target-20@3x.png';
import leadersImg from '../assets/images/icon-game-info-head-20@3x.png';
import ruleImg from '../assets/images/icon-game-info-rule-20@3x.png';
import infoImg from '../assets/images/icon-game-info-info-20@3x.png';
import moneyImg from '../assets/images/icon-game-info-money-20@3x.png';
import avatarImg from '../assets/images/image_userhead_90@3x.png';
import taskImg from '../assets/images/project_20.png';

const defaultName = 'FitGames用戶';

export function GameContent(props) {
    let history = useHistory();
    const { gid, popUpState, setPopUpState } = props;
    const openAppUrl = `https://fitgames.tw/applink?type=9&gid=${gid}`;

    const [rewardType, setRewardType] = useState({
        type: "",
        img: "",
        textStyle: "",
        timeTitle: "",
        startTime: "",
        endTime: "",
        startRegister: "",
        endRegister: "",
    });

    const { gameData } = props;

    useEffect(() => {
        props.getGame(gid);
    }, [gid]);

    useEffect(() => {
        if (gameData.pageNotFound) {
            history.push('/pageNotFound');
        }
    }, [gameData.pageNotFound]);

    useEffect(() => {
        setRewardType(
            gameData.rewardType === 0 ? {
                ...rewardType,
                type: "獎金賽",
                img: rewardImg,
                textStyle: "game-content-reward-text-head-color",
                startRegister: getDate(gameData.startRegister),
                endRegister: getDate(gameData.endRegister),
                timeTitle: "競賽時間",
                startTime: getDate(gameData.startTime) + " 至 ",
                endTime: getDate(gameData.endTime),
            } : gameData.rewardType === 1 ?
                {
                    ...rewardType,
                    type: "獎品賽",
                    img: rewardImg,
                    textStyle: "game-content-reward-text-head-color",
                    startRegister: getDate(gameData.startRegister),
                    endRegister: getDate(gameData.endRegister),
                    timeTitle: "競賽時間",
                    startTime: getDate(gameData.startTime) + " 至 ",
                    endTime: getDate(gameData.endTime),
                } : {
                    ...rewardType,
                    type: "自由賽",
                    img: freeImg,
                    textStyle: "game-content-reward-text-head-color-free ",
                    startRegister: "即日起",
                    endRegister: getDate(gameData.endRegister),
                    timeTitle: "開賽時間",
                    startTime: "完成報名(隔日起算)第 " + gameData.dueDay + " 天",
                    endTime: "",
                }
        );
    }, [gameData.rewardType]);

    const getRegisterPrice = () => {
        return (Intl.NumberFormat().format(gameData.price));
    }

    const getDate = (props) => {
        moment.locale('zh-tw')
        let dateLocal = moment(props * 1000).format('YYYY/MM/DD');
        return dateLocal;
    }

    const createMarkup = (props) => {
        let str = String(props);
        let re = /(\r\n)|(\n)/g;
        let reLink = /(https?:\/\/[\w\-/.?=&#]+)/g;

        let newStr = str.replace(re, "<br>").replace(reLink, "<a href='$1'>$1</a>");
        return { __html: newStr };
    }

    const handlePopUp = (props) => {
        setPopUpState({
            isOpen: !popUpState.isOpen,
            popUpType: props,
        })
    }

    const handleOpenApp = () => {
        window.open(openAppUrl, "_self");
    }

    const leaders = (gameData.leaders ? gameData.leaders : []);

    const tags = {
        get type() {
            if (gameData.tags) {
                if (gameData.tags.match(/UserCreated/g)) {
                    if (gameData.tags.match(/bonus/g)) {
                        return "獎金"
                    } else if (gameData.tags.match(/prize/g)) {
                        return "獎品"
                    } else if (gameData.tags.match(/truth/g)) {
                        return "聽到真心話"
                    } else if (gameData.tags.match(/advanture/g)) {
                        return "看到大冒險"
                    } else {
                        return ""
                    }
                }
            }
            return ""
        }
    }

    const RewardContent = () => {
        return (
            <div className="game-content-card-box-reward">
                <Row justify="space-between" style={{ margin: 0, height: "20px" }}>
                    <Col span={6}>
                        <div className={rewardType.textStyle}>
                            <img src={rewardType.img} className="game-content-icon-reward" alt="reward icon" />
                            {rewardType.type}
                        </div>
                    </Col>

                    <Col span={18} style={{ textAlign: "end" }}>
                        <p className="game-content-reward-text-head-gray">報名金額 {getRegisterPrice()} 元</p>
                    </Col>
                </Row>

                <p className="game-content-reward-text-title">
                    競賽獎項：
                </p>

                <Row type="flex" justify="center" align="middle" className={tags.type ? `game-content-reward-tag-${tags.type.length}` : "web-hidden"}>
                    <p className="game-content-reward-tag-font">{tags.type}</p>
                </Row>

                <p className="game-content-reward-text-title-color">
                    {gameData.reward}
                </p>

                <Divider className="game-content-divider" />

                <Row className="game-content-reward-item-box">
                    <Col span={2} className="game-content-reward-icon">
                        <img src={gameTimeImg} className="web-img" alt="time icon" />
                    </Col>
                    <Col span={20}>
                        <p className="game-content-reward-text-item-title">報名時間</p>
                        <p className="game-content-reward-text-item-sub">{rewardType.startRegister} 至 {rewardType.endRegister}</p>
                    </Col>
                </Row>

                <Row className="game-content-reward-item-box">
                    <Col span={2} className="game-content-reward-icon">
                        <img src={gameTimeImg} className="web-img" alt="time icon" />
                    </Col>
                    <Col span={20}>
                        <p className="game-content-reward-text-item-title">{rewardType.timeTitle}</p>
                        <p className="game-content-reward-text-item-sub">{rewardType.startTime}{rewardType.endTime}</p>
                    </Col>
                </Row>

                <Row className="game-content-reward-item-box">
                    <Col span={2} className="game-content-reward-icon">
                        <img src={targetImg} className="web-img" alt="time icon" />
                    </Col>
                    <Col span={20}>
                        <p className="game-content-reward-text-item-title">競賽目標</p>
                        <p className="game-content-reward-text-item-sub">{gameData.goal}</p>
                    </Col>
                </Row>

                <Row type="flex" justify="center" className="game-content-reward-app-box">
                    <button className="game-content-reward-app-btn" onClick={() => handlePopUp("game")}>
                        開啟App報名競賽
                    </button>
                </Row>

                <Row type="flex" justify="center" className="game-content-reward-open-box">
                    <button className="game-content-reward-app-btn" onClick={() => handleOpenApp()}>
                        立即報名
                    </button>
                </Row>

            </div>

        );
    }

    return (
        <div className="">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{gameData.title} - FitGames</title>
                <meta name='description' content={gameData.rule} />
                <meta property='og:title' content={`${gameData.title} - FitGames`} />
                <meta property='og:description' content={gameData.rule} />
            </Helmet>

            <Skeleton active avatar paragraph={{ rows: 16 }} loading={gameData.isLoading}>
                <div className="game-content-banner">
                    <img src={gameData.imgUrl} className="game-content-banner-img" alt="gamephoto" />
                </div>

                <div className="game-content-banner-header-box">
                    <div className="web-header">
                        <Row type="flex" justify="space-between" align="middle" gutter={[8, 8]}>
                            <Col>
                                <LogoButton transparent={true} />
                            </Col>
                            <Col>
                                <OpenAppButton popUpState={popUpState} setPopUpState={setPopUpState} transparent={true} game={true} />
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="game-content-box">
                    <Row type="flex" justify="start" gutter={[0, 0]}>
                        <Col order={1} className="game-content-breakpoint">
                            <Col span={24}>
                                <div className="game-content-card-box">
                                    <p className="game-content-text-title">{gameData.title}</p>
                                    <p className="game-content-text-subtitle">{gameData.subTitle}</p>

                                    <p className="game-content-text-host">
                                        <img src={hostImg} className="game-content-icon-small" alt="host icon" />{gameData.host}
                                    </p>
                                </div>
                            </Col>

                            {/* Reward Area Mobile */}
                            <Col span={24} className="game-content-reward-display">
                                {RewardContent()}
                            </Col>

                            {/* Leader Area */}
                            <Col span={24} className={gameData.leaders ? "" : "web-hidden"}>
                                <Row type="flex" align="middle" className="game-content-leaders-box">
                                    <Col className="game-content-icon">
                                        <img src={leadersImg} className="web-img" alt="leader icon" />
                                    </Col>
                                    <Col span={20}>
                                        <p className="game-content-item-text-title">競賽小隊長</p>
                                    </Col>

                                    <Col span={24}>
                                        <div className="game-content-leaders-card">
                                            {leaders.map((leader, index) => (
                                                <Row type="flex" align="middle" className={(index > 0) ? "game-content-leaders-item-box" : ""} key={index}>
                                                    <Col span={6}>
                                                        <img src={leader.imgUrl || avatarImg} className="game-content-leaders-img" alt="leader img" />
                                                    </Col>
                                                    <Col span={10}>
                                                        <p className="game-content-leaders-text">{leader.nickname || defaultName}</p>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            {/* Meta Area */}
                            <Col span={24}>
                                <Row type="flex" align="middle" className="game-content-meta-box">
                                    <Col className="game-content-icon">
                                        <img src={taskImg} className="web-img" alt="task icon" />
                                    </Col>
                                    <Col span={20}>
                                        <p className="game-content-item-text-title">競賽任務項目</p>
                                    </Col>
                                </Row>

                                <img src={gameData.taskImgUrl} className="game-content-meta-image" alt="task" />

                                <Row type="flex" className={gameData.task ? "game-content-meta-box-content" : "web-hidden"}>
                                    <div dangerouslySetInnerHTML={createMarkup(gameData.task)} className="game-content-meta-text-content" />
                                </Row>
                            </Col>

                            <Col span={24}>
                                <Row type="flex" align="middle" className="game-content-meta-box">
                                    <Col className="game-content-icon">
                                        <img src={ruleImg} className="web-img" alt="rule icon" />
                                    </Col>
                                    <Col span={20}>
                                        <p className="game-content-item-text-title">競賽規則</p>
                                    </Col>
                                </Row>

                                <img src={gameData.ruleImgUrl} className="game-content-meta-image" alt="rule" />

                                <Row type="flex" className="game-content-meta-box-content">
                                    <div dangerouslySetInnerHTML={createMarkup(gameData.rule)} className="game-content-meta-text-content" />
                                </Row>
                            </Col>

                            <Col span={24}>
                                <Row type="flex" align="middle" className="game-content-meta-box">
                                    <Col className="game-content-icon">
                                        <img src={infoImg} className="web-img" alt="info icon" />
                                    </Col>
                                    <Col span={20}>
                                        <p className="game-content-item-text-title">報名須知</p>
                                    </Col>
                                </Row>

                                <Row type="flex" className="game-content-meta-box-content">
                                    <div dangerouslySetInnerHTML={createMarkup(gameData.meta.applyTerm)} className="game-content-meta-text-content" />
                                </Row>
                            </Col>

                            <Col span={24}>
                                <Row type="flex" align="middle" className="game-content-meta-box">
                                    <Col className="game-content-icon">
                                        <img src={moneyImg} className="web-img" alt="money icon" />
                                    </Col>
                                    <Col span={20}>
                                        <p className="game-content-item-text-title">退費須知</p>
                                    </Col>
                                </Row>

                                <Row type="flex" className="game-content-meta-box-content">
                                    <div dangerouslySetInnerHTML={createMarkup(gameData.meta.refundTerm)} className="game-content-meta-text-content" />
                                </Row>
                            </Col>
                        </Col>

                        {/* Reward Area Web */}
                        <Col order={2} className="game-content-breakpoint-sub">
                            {RewardContent()}
                        </Col>
                    </Row>

                </div>

            </Skeleton>

        </div>
    );
}

const mapStateToProps = state => ({
    gameData: state.game,
});

const mapDispatchToProps = {
    getGame,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameContent);